import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OemService } from 'src/app/services/oem/oem.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss']
})
export class BrandComponent implements OnInit{

showNoRecordsFounds: boolean = false;
hovered: boolean = false;
hoveredIndex: any;
itemsPerPage = 9;
brands: any[] = [];
originalData: any[] = [];
paginatedItems: { name: string, logo: string }[] = [];
brandType: string = '';

constructor(
  private oemService :OemService,
  private router: Router,
  private readonly route: ActivatedRoute,
  private breakpointObserver: BreakpointObserver,
  private spinner: SpinnerService,
  private sharedService: SharedService
) { }

  ngOnInit(): void {
    this.scrollToTop();
    this.ShowItemsBasedonScreenSize();
    this.spinner.showSpinner();
    this.getAllBrandsList();
    this.spinner.hideSpinner();
  }

  visibilityChange(){
    
  }

  scrollToTop() {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    }else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  resetScrollSettings(): void {
    setTimeout(() => {
      const body = document.body;
      const html = document.documentElement;

      body.style.overflow = 'auto';
      html.style.overflow = 'auto';
    });
  }
  ShowItemsBasedonScreenSize() {
    this.breakpointObserver.observe([
      '(max-width: 768.98px)'
    ]).subscribe((result: any) => {
      if (result.matches) {
        if (result.breakpoints['(max-width: 768.98px)']) {
         this.resetScrollSettings();
        }
      }
    });
  }

  viewPortfolio(brand: any): void {
    this.router.navigate([`brands/brand-profile/${brand.id}`], {
      queryParams: { type: 'brand' }
    });
  }

  onPageChanged(paginatedData: any): void {
    // this.scrollToTop();
    this.paginatedItems = paginatedData[0];
  }

  getAllBrandsList(){
    this.spinner.showSpinner();
    this.oemService.getBrandsList().subscribe({
      next: (response) => {
        this.brands = response.data;
        this.originalData = this.brands;
        this.paginatedItems = this.brands.slice(0, this.itemsPerPage);
      },
      error: (error) => {
      }
    });
    this.spinner.hideSpinner();
  }

  filteredData = this.brands;

  onFilteredData(filtered: any): void {
    this.filteredData = filtered;
    this.brands = filtered;
    this.paginatedItems = this.filteredData.slice(0, this.itemsPerPage);
    if(this.paginatedItems.length == 0){
      this.showNoRecordsFounds = true
    } else {
      this.showNoRecordsFounds = false
    }
  }
}
